import { BaseModel } from "@blue-chip/core";
import Client from "./Client";
import Contact from "./Contact";

export default class ClientContact extends BaseModel {
  static get belongsTo() {
    return [Client, Contact];
  }
}
